<mat-sidenav-container
  hasBackdrop="false"
  [attr.fullscreen]="_demoOnly ? null : ''"
  [ngStyle]="{ height: _demoOnly ? '600px' : '100%' }"
>
  <mat-sidenav
    mode="over"
    [opened]="true"
    [ngStyle]="{ 'width.em': roleId === 'client' ? '0' : sidenavWidth }"
    disableClose
  >
    <div class="mat-sidenav-inner">
      <aside
        class="sidenav-top-row mat-elevation-z8"
        (click)="sidenavClicked($event)"
      >
        <div
          *ngIf="sidenavWidth == sidenavMaxWidth && sideNavDocked"
          [ngClass]="{
            logo: sidenavWidth == sidenavMaxWidth,
            'logo-small': sidenavWidth == sidenavMinWidth
          }"
          class="clickable-icon"
        >
          <img class="academy-logo" [src]="Logo" />
        </div>
        <mat-icon
          class="minimize-icon clickable-icon"
          *ngIf="sidenavWidth == sidenavMaxWidth && sideNavDocked"
        >
          format_indent_decrease</mat-icon
        >
        <mat-icon
          class="minimize-icon clickable-icon"
          *ngIf="sidenavWidth == sidenavMinWidth && !sideNavDocked"
        >
          format_indent_increase</mat-icon
        >
      </aside>
      <nav
        class="nav"
        [ngClass]="{
          'demo-only': !sideNavDocked && _demoOnly,
          'nav-small': sideNavDocked && _demoOnly
        }"
      >
        <bolt-menu-item
          [navigationOptions]="navigationOptions"
          [isexpand]="sidenavWidth == sidenavMaxWidth"
          [level]="1"
        >
        </bolt-menu-item>
      </nav>
      <aside
        class="sidenav-bottom-row mat-elevation-z8"
        *ngIf="sidenavWidth === sidenavMaxWidth"
      >
        <!-- <div class="powered-by-image">
          <span>Product By</span>
          <img class="academy-logo" [src]="camLogoHo" />
        </div> -->
      </aside>
    </div>
  </mat-sidenav>

  <mat-sidenav-content
    [ngClass]="{
      'slide-right': sideNavDocked,
      'mat-content-inner': !sideNavDocked,
      'full-screen': roleId === 'client'
    }"
  >
    <!-- <div class="mat-content-inner"> -->
    <div class="header mat-elevation-z5">
      <app-header></app-header>
    </div>
    <div
      #content
      class="sidenav-content-div"
      [ngStyle]="{ 'padding-left': _demoOnly ? '10px' : '0' }"
    >
      <div style="height: 100%">
        <ng-content></ng-content>
      </div>

      <!-- <div
        class="scroll-to-top"
        [ngClass]="{ 'show-scrollTop': windowScrolled }"
      >
        <bolt-button type="link" (click)="scrollToTop()">
          Back to Top
      </bolt-button>
      </div> -->
    </div>
    <!-- </div> -->
  </mat-sidenav-content>
</mat-sidenav-container>
